import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector, reset } from "redux-form";
import axios from "axios";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { connect } from "react-redux";
import appConfig from '../../config/config';
import {Loading,LoadingDone,Reset,Success,Error, HideAddDeed} from "../../actions/loading"
import Banner from "../common/banner";
import DeedForm from "./DeedForm";

class PropertyReportDeed extends Component {
    constructor(props) {
        super(props);
    }
    // if property contains data 
    componentDidMount() {
    }

    submit = (values) => {
        console.log(values)
        var v = JSON.stringify({
            ...values, OrderId: this.props.OrderId, 
            //OrderProductId: this.props.OrderProductId,
            Action: "Deed",
            UserName: this.props.session.session.user.name
        });
        this.props.Loading()
        axios.post(
            appConfig.apiGateway.updatePropertyReport,
            v,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then((response) => {
            this.props.LoadingDone()
            this.props.Success("Saved Data")
            if (response.data.Count > 0) {
                var myObject = JSON.parse(response.data.body);
            }
        },
        (error) => {
            this.props.LoadingDone()
            this.props.Error("Some error")
        });

    }
    toggle = tab => {
        if (this.state.activeTab !== tab)
            this.setState(prevState => ({
                ...prevState, activeTab: tab
            }));
    }
    render() {
        console.log(this)
        return (
            <>
            <Modal
                isOpen={this.props.displayadd}
                contentClassName="custom-large-modal-style"
              >
                <form onSubmit={this.props.handleSubmit(this.submit)} style={{ marginLeft: "0%", marginRight: "0%" }}>
                    <ModalHeader>
                        Add Deed
                    </ModalHeader>
                    <ModalBody>
                    {/* {this.props.loading.showBanner && (
                      <Banner
                        Close={()=> this.props.Reset()}
                        message={this.props.loading.message}
                        IsSuccess={this.props.loading.isSuccess}
                      />
                    )} */}
                        <DeedForm  />
                    </ModalBody>
                    <ModalFooter>

                        <div className="col-12 pb-2 text-right">
                            <Button color="primary" type="submit" className="mr-3">Save</Button>
                            <Button type="button" onClick={()=> this.props.HideAddDeed()}>Cancel</Button>
                        </div>
                    </ModalFooter>
                </form>
              </Modal>
            </>
        );
    }
}

const validate = (formValues) => {
    const errors = {};
    return errors;
}
var propertyReportDeedForm = reduxForm({
    form: 'propertyReportDeedForm',
    validate,
    enableReinitialize: true
})(PropertyReportDeed);

propertyReportDeedForm = connect(
    state => ({
        session: state.session,
        displayadd: state.loadDeed.displayadd,
        initialValues: state.loadDeed.deeddata,
        loading : state.loading
    }),
    {LoadingDone,Loading,Success,Error,Reset,HideAddDeed}
)(propertyReportDeedForm);

export default propertyReportDeedForm;